// DS: i9.11
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const DollarHeart: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.023 28h-2v2h2v-2ZM19 26h-2v2h2v-2Z" fill="#000" />
        <path d="M17 26h-2v2h2v-2Z" fill="#51D879" />
        <path d="M15 26h-2v2h2v-2Z" fill="#000" />
        <path d="M15 24h-2v2h2v-2Z" fill="#76DE98" />
        <path d="M17 24h-2v2h2v-2ZM19 24h-2v2h2v-2Z" fill="#51D879" />
        <path d="M21 24h-2v2h2v-2ZM13 24h-2v2h2v-2Z" fill="#000" />
        <path d="M15 22h-2v2h2v-2ZM17 22h-2v2h2v-2Z" fill="#76DE98" />
        <path
          d="M19 22h-2v2h2v-2ZM21 22h-2v2h2v-2ZM21 20h-2v2h2v-2ZM23 20h-2v2h2v-2ZM23 18h-2v2h2v-2ZM25 18h-2v2h2v-2ZM25 16h-2v2h2v-2ZM27 16h-2v2h2v-2ZM27 14h-2v2h2v-2ZM29 14h-2v2h2v-2ZM29 12h-2v2h2v-2ZM29 10h-2v2h2v-2ZM29 8h-2v2h2V8Z"
          fill="#51D879"
        />
        <path
          d="M27 18h-2v2h2v-2ZM29 16h-2v2h2v-2ZM31 14h-2v2h2v-2ZM31 12h-2v2h2v-2ZM31 10h-2v2h2v-2ZM31 8h-2v2h2V8ZM29 6h-2v2h2V6ZM27 4h-2v2h2V4ZM25 2h-2v2h2V2ZM23 2h-2v2h2V2ZM21 2h-2v2h2V2ZM19 4h-2v2h2V4ZM15 4h-2v2h2V4ZM7 4H5v2h2V4ZM5 6H3v2h2V6ZM3 8H1v2h2V8ZM3 10H1v2h2v-2ZM3 12H1v2h2v-2ZM13 2h-2v2h2V2ZM11 2H9v2h2V2ZM9 2H7v2h2V2ZM17 6h-2v2h2V6ZM25 20h-2v2h2v-2ZM23 22h-2v2h2v-2Z"
          fill="#000"
        />
        <path d="M13 22h-2v2h2v-2Z" fill="#76DE98" />
        <path d="M11 22H9v2h2v-2Z" fill="#000" />
        <path d="M11 20H9v2h2v-2ZM9 18H7v2h2v-2ZM7 16H5v2h2v-2ZM5 14H3v2h2v-2Z" fill="#76DE98" />
        <path
          d="M5 14H3v2h2v-2ZM13 20h-2v2h2v-2ZM15 20h-2v2h2v-2ZM17 20h-2v2h2v-2ZM19 20h-2v2h2v-2ZM21 18h-2v2h2v-2ZM21 16h-2v2h2v-2ZM23 16h-2v2h2v-2ZM23 14h-2v2h2v-2ZM25 14h-2v2h2v-2ZM25 12h-2v2h2v-2ZM27 12h-2v2h2v-2ZM27 10h-2v2h2v-2Z"
          fill="#76DE98"
        />
        <path
          d="M27 8h-2v2h2V8ZM11 18H9v2h2v-2ZM13 18h-2v2h2v-2ZM15 18h-2v2h2v-2ZM17 18h-2v2h2v-2ZM19 18h-2v2h2v-2ZM11 16H9v2h2v-2ZM11 14H9v2h2v-2ZM11 12H9v2h2v-2ZM11 10H9v2h2v-2ZM9 16H7v2h2v-2ZM9 14H7v2h2v-2ZM9 12H7v2h2v-2ZM7 12H5v2h2v-2ZM5 12H3v2h2v-2ZM7 14H5v2h2v-2ZM9 10H7v2h2v-2ZM9 8H7v2h2V8ZM7 10H5v2h2v-2ZM5 10H3v2h2v-2ZM13 12h-2v2h2v-2ZM7 8H5v2h2V8ZM5 8H3v2h2V8ZM13 16h-2v2h2v-2ZM13 14h-2v2h2v-2ZM13 10h-2v2h2v-2Z"
          fill="#9EFC36"
        />
        <path
          d="M15 10h-2v2h2v-2ZM17 10h-2v2h2v-2ZM15 8h-2v2h2V8ZM15 6h-2v2h2V6ZM19 6h-2v2h2V6ZM21 4h-2v2h2V4ZM23 4h-2v2h2V4ZM25 4h-2v2h2V4ZM11 8H9v2h2V8ZM13 8h-2v2h2V8ZM17 8h-2v2h2V8ZM11 6H9v2h2V6ZM11 4H9v2h2V4ZM13 6h-2v2h2V6ZM9 6H7v2h2V6ZM7 6H5v2h2V6ZM13 4h-2v2h2V4ZM9 4H7v2h2V4Z"
          fill="#D2F1B4"
        />
        <path
          d="M15 16h-2v2h2v-2ZM15 14h-2v2h2v-2ZM15 12h-2v2h2v-2ZM17 16h-2v2h2v-2ZM17 14h-2v2h2v-2ZM17 12h-2v2h2v-2ZM19 16h-2v2h2v-2ZM19 14h-2v2h2v-2ZM19 12h-2v2h2v-2ZM19 10h-2v2h2v-2Z"
          fill="#9EFC36"
        />
        <path d="M19 8h-2v2h2V8Z" fill="#D2F1B4" />
        <path
          d="M21 12h-2v2h2v-2ZM23 12h-2v2h2v-2ZM21 10h-2v2h2v-2ZM23 10h-2v2h2v-2ZM25 10h-2v2h2v-2ZM21 14h-2v2h2v-2ZM21 8h-2v2h2V8ZM23 8h-2v2h2V8ZM25 8h-2v2h2V8Z"
          fill="#9EFC36"
        />
        <path d="M21 6h-2v2h2V6Z" fill="#D2F1B4" />
        <path d="M23 6h-2v2h2V6ZM25 6h-2v2h2V6ZM27 6h-2v2h2V6Z" fill="#9EFC36" />
        <path
          d="M9 20H7v2h2v-2ZM7 18H5v2h2v-2ZM5 16H3v2h2v-2ZM3 14H1v2h2v-2ZM17.006 10.4H15v1.714h2.006V10.4ZM19.006 12.114H17v1.714h2.006v-1.714ZM15.006 12.114H13v1.714h2.006v-1.714ZM15.006 13.829H13v1.714h2.006v-1.714Z"
          fill="#000"
        />
        <path d="M15.006 15.543H13v1.714h2.006v-1.714Z" fill="#000" />
        <path d="M17.006 15.543H15v1.714h2.006v-1.714Z" fill="#000" />
        <path
          d="M19.006 15.543H17v1.714h2.006v-1.714ZM19.006 17.257H17v1.714h2.006v-1.714Z"
          fill="#000"
        />
        <path d="M19.006 18.971H17v1.715h2.006V18.97Z" fill="#000" />
        <path
          d="M17.006 18.971H15v1.715h2.006V18.97ZM17.006 20.686H15V22.4h2.006v-1.714Z"
          fill="#000"
        />
        <path
          d="M15.006 18.971H13v1.715h2.006V18.97ZM17.006 12.114H15v1.714h2.006v-1.714Z"
          fill="#000"
        />
      </svg>
    </IconWrap>
  );
};
DollarHeart.displayName = 'DollarHeart';

export default DollarHeart;
